import { DbtIcon } from "@/assets/icons";
import {
  SnowflakeIcon,
  PostgresIcon,
  S3Icon,
  BigQueryIcon,
  MySqlIcon,
  TableauIcon,
  DatabricksIcon,
} from "@assets/images";
import { capitalize, lowerCase } from "lodash";

export const GET_DATASTORE_TYPES = "GET-DATASTORE-TYPES";

export const DatastoresIconMap = {
  postgres: PostgresIcon,
  snowflake: SnowflakeIcon,
  s3: S3Icon,
  bigquery: BigQueryIcon,
  mysql: MySqlIcon,
  tableau: TableauIcon,
};

// PR #2155 review (F13): inline `style={{ width:"1.8em", height:"1.8em" }}`
// replaced with Tailwind utilities. `al-w-7 al-h-7` is the closest token
// for the previous 1.8em sizing at the default 16px root.
const SVG_ICON_SIZE = "al-w-7 al-h-7";

export const getIconByDatastoreType = (
  datastoreType: string,
  className?: string
): JSX.Element | null => {
  // PR #2155 review (F3 accessibility): wrap SVG-based icons in an element
  // with `role="img"` + `aria-label` so screen readers announce them the
  // same way the `<img alt="...">` icons are announced.
  if (datastoreType === "dbt") {
    return (
      <div className={`${className || ""} ${SVG_ICON_SIZE}`} role="img" aria-label="dbt">
        <DbtIcon />
      </div>
    );
  }

  if (datastoreType === "databricks") {
    return (
      <div
        className={`${className || ""} ${SVG_ICON_SIZE}`}
        role="img"
        aria-label="Databricks"
      >
        <DatabricksIcon />
      </div>
    );
  }

  const icon =
    DatastoresIconMap[lowerCase(datastoreType).replace(/ /g, "") as keyof typeof DatastoresIconMap];
  if (!icon) return null;

  return <img src={icon} alt={capitalize(datastoreType)} className={className || ""} />;
};
